import React, { useState, useEffect } from 'react';

/**
 * Body-wide loading overlay component
 * Shows a centered spinner that covers the entire body (excluding header and footer)
 */
function BodyLoader() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Hide loader after a short delay to allow page to load
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="body-loading-overlay">
      <div className="body-loading-spinner"></div>
      <div className="body-loading-text">Loading...</div>
    </div>
  );
}

export default BodyLoader;
